import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button } from 'storybook-ui'

import { FooterContainer } from 'components/FooterContainer'
import { Header } from 'components/Header'

import { selectAppName } from 'root-redux/selects/common'

import { useContactFormNavigation } from 'hooks/useContactFormNavigation'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'

import { APP_BUTTON_THEMES, AppName } from 'root-constants'

import { StyledNotFound as S } from './NotFound.styles'

export const NotFound: React.FC = () => {
  const { t } = useTranslation()
  const appName = useSelector(selectAppName)
  const { goToContactForm } = useContactFormNavigation()

  const onClickContactSupportTeam = () => {
    goToContactForm(appName)
  }

  return (
    <>
      <Header />
      <S.Root>
        <S.Title>{t('somethingWrong')}</S.Title>
        <S.PinnedNoteWrapper>
          <PinnedNote>{t('notFound.description')}</PinnedNote>
        </S.PinnedNoteWrapper>
      </S.Root>
      <FooterContainer>
        <Button
          theme={APP_BUTTON_THEMES[appName || AppName.SPILIO]}
          onClick={onClickContactSupportTeam}
        >
          {t('notFound.contactSupportTeam')}
        </Button>
      </FooterContainer>
    </>
  )
}
